module.exports = __webpack_public_path__ + "static/media/logo-p-500.e04c96c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-p-500.png
// module id = 482
// module chunks = 0